import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-it',
  templateUrl: './privacy-it.component.html',
  styleUrls: ['../privacy.component.css']
})
export class PrivacyItComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
